import React from 'react'

import BudgetPreview from './Previews/BudgetPreview'
import BidPricePreview from './Previews/BidPricePreview'

const TikTokLineItemBudgetSectionPreview = ({ lineItem }) => {
  return (
    <p>
      <BudgetPreview lineItem={lineItem} />
      <BidPricePreview lineItem={lineItem} />
    </p>
  )
}

export default TikTokLineItemBudgetSectionPreview
